import 'ui-core/widgets/export-citations/js/export-citations';

UX.exportCitation.control = function () {
    $(document).ready(function () {
        if ($('.exportCitationWrapper').length) {
            $('.articles-toolbar, .exportCitationCheckbox').removeClass('js--hidden');
        }
    });

    $(document).on('click', '.export-citations__submit', function (e) {
        e.preventDefault();

        let $this = $(this),
            submitTargetedForm = $this.data('form');

        $(submitTargetedForm).submit();
    });

    $(document).on('click', '.articles-toolbar-option', function () {
        let $this = $(this),
            $body = $('body'),
            dataTarget = $this.data('target'),
            accessType = $this.data('access-type'),
            $exportCitationChecked = $body.find('[data-type="exportCitation"]:checked');

        if ($exportCitationChecked.length) {
            $('[data-type="filled"]').show();
            $('[data-type="empty"]').hide();
            UX.exportCitation.collectDois($exportCitationChecked, dataTarget, accessType);
        } else {
            $('[data-type="empty"]').show();
            $('[data-type="filled"]').hide();
        }
    });

    $(document).on('change', '.selectAllCitation', function () {
        let $this = $(this);

        if ($($this).is(':checked')) {
            $('[data-type="exportCitation"]').prop('checked', true);
            $this.next('.label-txt').attr('aria-label', 'Deselect all articles');
        } else {
            $('[data-type="exportCitation"]').prop('checked', false);
            $this.next('.label-txt').attr('aria-label', 'Select all articles');
        }
    });

    $(document).on('change', '[data-type="exportCitation"]', function () {
        if (!$(this).is(':checked') && $('.selectAllCitation').is(':checked')) {
            $('.selectAllCitation').prop('checked', false);
        }
        if (!$('[data-type="exportCitation"]:not(:checked)').length) {
            $('.selectAllCitation').prop('checked', true);
        }
    });
};

UX.exportCitation.collectDois = function (collectedDoi, dataTarget, accessType) {
    let $collectedDoisForm = $(dataTarget),
        $collectedDois = $collectedDoisForm.find('.collectedDois'),
        $collectedDoisNum = $collectedDoisForm.find('.collectedDoisNum'),
        $pdfSize = $collectedDoisForm.find('.pdfSize'),
        doisCounter = 0,
        avaliableDoisCounter = 0,
        pdfSizeCounter = 0,
        multiText = '';

    $collectedDois.html('');
    $collectedDoisNum.html('');
    $(collectedDoi).each(function (index, doi) {
        $collectedDois.append('<input type="hidden" name="doi" value="' + $(doi).val() + '"/>');
        doisCounter++;
        if ($(doi).data('pdf-size')) {
            pdfSizeCounter += parseFloat($(doi).data('pdf-size'));
            avaliableDoisCounter++;
        }
    });

    $pdfSize.text(pdfSizeCounter.toFixed(1));

    multiText = doisCounter > 1 ? 's' : '';

    switch (dataTarget) {
        case '#exportCitation':
            $collectedDoisNum.html(
                '<p>You have chosen to export&nbsp;<span>' + doisCounter + '</span>&nbsp;citation' + multiText + '.</p>'
            );
            break;
        case '#pdfDownload':
            switch (accessType) {
                case 'all':
                    $collectedDoisNum.html(
                        '<p>You have chosen to download&nbsp;<span>' +
                            doisCounter +
                            '</span>&nbsp;PDF' +
                            multiText +
                            '.</p>'
                    );
                    break;
                case 'some':
                    $collectedDoisNum.html(
                        '<p>You can continue to download&nbsp;<span>' +
                            avaliableDoisCounter +
                            '</span>&nbsp;PDF' +
                            multiText +
                            '&nbsp;of the ' +
                            doisCounter +
                            ' you have selected.</p>'
                    );
                    break;
                case 'full-book':
                    $collectedDoisNum.html(
                        '<p>Continue to download&nbsp;<span>' +
                            avaliableDoisCounter +
                            '</span>&nbsp;PDF' +
                            multiText +
                            '.</p>'
                    );
                    break;
            }
            break;
    }
};
